module.exports = __webpack_public_path__ + "static/media/Boost.2fc42c14.png";